<template>
    <!--垫税提额 -->
    <div class="my-quota">
        <!-- <el-tabs v-model="taxAdvances" class="demo-tabs" @tab-click="handleClick">
            <el-tab-pane label="申请记录" name="first">
                <el-button type="primary" :loading="exploading" @click="exportFile">导出</el-button>

                <el-divider style="border-top:1px solid #F0F2F5;margin:20px 0"/>

                <ab-table
                    class="materialTable"
                    ref="table"
                    stripe
                    showSelection
                    selectionWidth="45"
                    indexWidth="50"
                    widths="140"
                    isFilter="clientNumber"
                    :column-list="columns"
                    :table-list="tableData"
                    :dataListLoading="isloading"
                    :handleSelectionChange="handleSelectionChange"
                    @filterColumns="filterColumns"
                >

                    <template #clientNumber='scope'>
                        <el-button type="primary" link v-if="scope.row.brandName=='受理中'">纳税申请表</el-button>
                        <el-button type="primary" link v-else>重签结算页</el-button>
                    </template>
                    <template #brandName="scope">
                        <div>
                            <span :class="getStatusClass(scope.row.brandName)"></span>{{scope.row.brandName}}
                        </div>
                    </template>

                    <template #auditStatusDesc="scope">
                        <p>{{scope.row.auditStatusDesc}} <span @click="openLinkUrl(scope.row.linkUrl)" style="cursor: pointer; color: #0b7aff" v-if="scope.row.auditStatus == 'ApplyAmountAudit' && scope.row.linkUrl">>>去签署</span></p>
                    </template>
                    <template #applyDesc="scope">
                        <el-button link type="primary" @click="viewFile(scope.row)" v-if="scope.row.applyDesc !== '自动授信'">{{scope.row.applyDesc}}</el-button>
                        <p v-if="scope.row.applyDesc == '自动授信'">{{scope.row.applyDesc}}</p>
                    </template>

                </ab-table>

            </el-tab-pane>

            <el-tab-pane label="变化历史" name="second">
                <div class="top">
                    <el-button type="primary" :loading="linesLoad" @click="linesHistory">导出</el-button>
                    <div class="right">累积额度变化值：<span class="green">+{{$filters.formatMoney(logSum.amountPlus)}}元</span> <span class="red">{{$filters.formatMoney(logSum.amountSub)}}元</span></div>
                </div>
                
                <el-divider style="border-top:1px solid #F0F2F5;margin:20px 0"/>

                <ab-table
                    class="materialTable"
                    ref="table"
                    stripe
                    showSelection
                    selectionWidth="45"
                    indexWidth="50"
                    widths="140"
                    isFilter="inspectionQuarantineDesc"
                    :column-list="columns1"
                    :table-list="tableData1"
                    :dataListLoading="isloading"
                    :handleSelectionChange="handleSelectionChange"
                    @filterColumns="filterColumns"
                >
                </ab-table>

                <div class="list-page">
                    <ab-page
                        :pageTotal="page.total"
                        :currentPage="page.currentPage"
                        :pageSize="page.pageSize"
                        :pageSizes="page.pageSizes"
                        @searchForm="pageSearch"
                    ></ab-page>
                </div>

            </el-tab-pane>
        </el-tabs>
 -->

        <el-button type="primary" :loading="exploading" @click="exportFile">导出</el-button>

        <el-divider style="border-top:1px solid #F0F2F5;margin:20px 0"/>

        <ab-table
            class="materialTable"
            ref="table"
            stripe
            showSelection
            selectionWidth="45"
            indexWidth="50"
            widths="140"
            isFilter="clientNumber"
            :column-list="columns"
            :table-list="tableData"
            :dataListLoading="isloading"
            :handleSelectionChange="handleSelectionChange"
            @filterColumns="filterColumns"
        >

            <template #clientNumber='scope'>
                <el-button type="primary" link v-if="scope.row.brandName=='受理中'">纳税申请表</el-button>
                <el-button type="primary" link v-else>重签结算页</el-button>
            </template>
            <template #brandName="scope">
                <div>
                    <span :class="getStatusClass(scope.row.brandName)"></span>{{scope.row.brandName}}
                </div>
            </template>

            <template #auditStatusDesc="scope">
                <p><span :class="getStatusClass(scope.row.auditStatusDesc)"></span>{{scope.row.auditStatusDesc}} <span @click="openLinkUrl(scope.row.linkUrl)" style="cursor: pointer; color: #0b7aff" v-if="scope.row.auditStatus == 'ApplyAmountAudit' && scope.row.linkUrl">>>去签署</span></p>
            </template>

            <template #applyDesc="scope">
                <el-button link type="primary" @click="viewFile(scope.row)" v-if="scope.row.applyDesc !== '自动授信'">{{scope.row.applyDesc}}</el-button>
                <p v-if="scope.row.applyDesc == '自动授信'">{{scope.row.applyDesc}}</p>
            </template>
        </ab-table>

        <ab-preview :preview="preview"></ab-preview>
        <ab-preview :preview="preview1"  @handleClose="handleClose1">
            <template slot="button">
                <el-button @click="handleClose1">关 闭</el-button>
            </template>
        </ab-preview>

        <ab-downloadFile :dialog="fileView"></ab-downloadFile>
    </div>
</template>

<script>
export default {
    name: 'my-quota',
    data() {
        return {
           taxAdvances:'first',
            //申请记录
            page: {
                currentPage: 1, //当前页
                pageSize: 10, //每页展示的数据个数
                pageSizes: [10, 20, 50, 100],
                total: 0,
            },
            linesLoad: false,
            //附件参数
            fileView: {
                title:'附件',
                sourceBillId: '',
                sourceBillNumber: '',
                sourceBillType: 'credit',
                isviewFileUrl: true,
                show: false,
                items: [
                    {
                        title: '上年12个月及近1个月企业纳税申请表（所得税）',
                        attachType: '010'
                    },
                    {
                        title: '上年12个月及近1个月企业纳税申请表（增值税）',
                        attachType: '020'
                    },
                    {
                        title: '其他材料',
                        attachType: '030'
                    }]
            },
            columns: [
                {
                    props: "createTime",
                    labels: "申请时间",
                    widths: 100,
                },
                {
                    props: "amountTypeDesc",
                    labels: "额度类型",
                    widths: 100,
                },
                {
                    props: "applyAmount",
                    labels: "申请额度",
                    widths: 60,
                    type:'money',
                    align:"right"
                },
                {
                    props: "approveAmount",
                    labels: "获批额度",
                    widths: 100,
                    type:'money',
                    align:"right"
                },
                {
                    props: "auditStatusDesc",
                    labels: "申请状态",
                    widths: 100, 
                    slot: "slot",
                },
                {
                    props: "createTime",
                    labels: "完成时间",
                    widths: 100,
                },
                {
                    props: "applyDesc",
                    labels: "申请材料",
                    widths: 60,
                    slot: "slot",
                },
            ],
            tableData: [
                
            ],

            //变化历史
            page1: {
                currentPage: 1, //当前页
                pageSize: 10, //每页展示的数据个数
                pageSizes: [10, 20, 50, 100],
                total: 0,
            },
            columns1: [
                {
                    props: "number",
                    labels: "来源单号",
                    widths: 100,
                },
                {
                    props: "amountTypeDesc",
                    labels: "额度类型",
                    widths: 100,
                },
                {
                    props: "bizTypeDesc",
                    labels: "业务类型",
                    widths: 100,
                },
                {
                    props: "changeTypeDesc",
                    labels: "变化类型",
                    widths: 100,
                },
                {
                    props: "createTime",
                    labels: "发生时间",
                    widths: 100, 
                },
                {
                    props: "changeAmount",
                    labels: "额度变化值",
                    widths: 100,
                    align: 'right',
                    type:'money'
                },
                {
                    props: "financingSum",
                    labels: "当前子额度",
                    widths: 100,
                    align: 'right',
                    type:'money'
                },
                {
                    props: "freeSum",
                    labels: "剩余子额度",
                    widths: 100,
                    align: 'right',
                    type:'money'
                },
                {
                    props: "currencyCode",
                    labels: "币别",
                    widths: 60,
                },
            ],
            tableData1: [
                
            ],
            logSum: {},
            exploading: false,
            preview: {
                show: false,
                isView: false,
                isFooter: true,
                fileUrl: ""
            },
            preview1: {
                show: false,
                isView: false,
                isFooter: true,
                fileUrl: ""
            }
        }
    },
    mounted () {
        this.searchForm()
    },
    methods: {
        //申请记录
        pageSearch(obj) {
            this.page.currentPage = obj.currentPage
            this.page.pageSize = obj.pageSize
            this.getListData()
        },       
        getStatusClass(val){
            let cls
            switch(val){
                case '受理中': 
                    cls = 'status-FF8400'
                break
                case '申请失败': 
                    cls = 'status-E21010'
                break
                case '申请通过': 
                    cls = 'status-0AB2A8'
                break
            }
            return cls
        },
        filterColumns (array) {
            this.columns = array
        }, 

        searchForm() {
            this.page.currentPage = 1
            if (this.taxAdvances == 'first') {
                this.getClientCreditAmount()
            } else {
                this.getListData()
            }
        },
        getListData() {
            let data = Object.assign(
                { data: this.formSearch },
                { pageNum: this.page.currentPage, pageSize: this.page.pageSize }
            )
            this.isLoading = true
            this.$post("/bas/client/ClientCreditAmount/logList", data).then(
                res => {
                if (res.data.code == "C0000") {
                    if(res.data.result) {
                        if(res.data.result.list  && res.data.result.list.length > 0) {
                            this.tableData1 = res.data.result.list
                        }
                        this.page.total = Number(res.data.result.total)
                        this.logSum = {
                            count: res.data.result.count,
                            amountPlus: res.data.result.changeAmountPlus || 0,
                            amountSub: res.data.result.changeAmountSub || 0
                        }
                    }
                }
            }).finally(() => {
                this.isLoading = false
            })
        },
        getClientCreditAmount() {
            this.isLoading = true
            this.$get('/bas/client/ClientCreditAmount/get').then(({data}) => {
                if(data.code === 'C0000') {
                    if(data.result) {
                        this.tableData = data.result.changeRecordList
                    }
                }
            }).finally(() => {
                this.isLoading = false
            })
        },
        handleClick () {
            setTimeout(() => {
                if (this.taxAdvances == 'first') {
                    this.getClientCreditAmount()
                } else {
                    this.getListData()
                }
            }, 50)
        },
        exportFile () {
            this.exploading = true
            let excelField = this.columns.map(e => e.props)
            this.$post('/bas/client/ClientCreditAmount/export', {
                excelField,
                data: this.tableData
                }).then(({ data }) => {
                if (data && data.code === "C0000") {
                    // 创建隐藏的可下载链接
                    var eleLink = document.createElement('a')
                    eleLink.download = ''
                    eleLink.style.display = 'none'
                    // 字符内容转变成blob地址
                    eleLink.href = data.result
                    // 触发点击
                    document.body.appendChild(eleLink)
                    eleLink.click()
                    // 然后移除
                    document.body.removeChild(eleLink)
                    } else {
                    this.$message.error(data.message)
                }
            }).finally(() => {
                this.exploading = false
            })
        },
        openLinkUrl (url) {
            this.preview1.fileUrl = url
            this.preview1.show = true
            this.preview1.isView = true
        },
        handleClose1() {
            this.dialogVisible = false
            this.preview1.show = false
            this.searchForm()
        },
        //修改问题
        viewFile(row){
            if(row.applyDesc == '重签结算页' && row.fileUrl) {
                window.open(row.fileUrl)
            }else{
                this.fileView.sourceBillId = row.id
                this.fileView.sourceBillNumber = this.fileView.sourceBillId.toString()
                this.fileView.show = true
            }
        },
        //变化历史
        linesHistory(){
            this.linesLoad = true
            let excelField = this.columns1.map(e => e.props)
            this.$post('/bas/client/ClientCreditAmount/exportUse', {
                amountType: "1" ,
                principalId: this.tableData1?this.tableData1[0].principalId: '',
                excelField
            }).then(({ data }) => {
                if (data && data.code === "C0000") {
                    // 创建隐藏的可下载链接
                    var eleLink = document.createElement('a')
                    eleLink.download = ''
                    eleLink.style.display = 'none'
                    // 字符内容转变成blob地址
                    eleLink.href = data.result
                    // 触发点击
                    document.body.appendChild(eleLink)
                    eleLink.click()
                    // 然后移除
                    document.body.removeChild(eleLink)
                    } else {
                    this.$message.error(data.message)
                }
            }).finally(() => {
                this.linesLoad = false
            })
        }
    }
}
</script>

<style lang="scss">
.my-quota{
    text-align: left;
    color: #000000;
    padding: 20px 20px 20px 20px;
    /*去掉切换时el-tab-pane底部的蓝色下划线*/
    .el-tabs__active-bar {
      background-color: transparent !important;
    }
    /*去掉tabs底部的下划线*/
    .el-tabs__nav-wrap::after {
      position: static !important;
    }
    .el-tabs__item.is-top {
      padding: 0;
      margin-right: 40px;
      font-size: 14px;
      &.is-active {
        background-image: url(@/assets/img/nav-active.png);
        background-repeat: no-repeat;
        background-position: center 27px;
        border-bottom: none;
        font-size: 16px;
      }
    }
    .title{
        font-size: 16px;
        // color: #0A7CFF;
        color: #000000;
        margin-bottom: 16px;
    }
    #pane-second{
        .top{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .right{
                font-size: 14px;
                .green{
                    color: #0AB2A8;
                }
                .red{
                    color:#FF0000
                }
            }
            
        }
    }


    .list-page {
        padding: 10px 0;
        .el-pagination {
            justify-content: center;
            .btn-prev, .btn-next {
                width: 76px;
                height: 36px;
                border: 1px solid #C4C6CF;
                background-color: #ffffff;
                border-radius: 30px;
                margin:0 10px;
            }
            .el-pager {
                .number,
                .btn-quickprev,
                .btn-quicknext {
                    border: 1px solid #C4C6CF;
                    background-color: #ffffff;
                    border-radius: 50%;
                    height: 36px;
                    width:36px;
                    margin-right: 10px;
                }
                .is-active {
                    background-color: #0A7CFF;
                    color: #ffffff;

                }
            }
             
        }
    }
    .el-tabs__header {
        margin-bottom: 13px;
    }
    .el-tabs__item.is-top.is-active {
        line-height: 18px;
    }
}
</style>